<div id="{{ componentId }}" class="vtr-ui-list-checkbox-hardware">
	<ul id="{{ componentId }}-list" class="list-group">
		<div class="col-12 px-0">
			<li id="{{ componentId }}-list-item-{{ id }}" class="list-group-item" *ngFor="let device of devices; let id = index">
				<div class="row">
					<vtr-material-checkbox
						[componentId]="componentId + '-list-item-' + id + '-checkbox'"
						[ariaLabel]="'hardwareScan.pluginTokens.' + device.title | translateDefault:device.title"
						[checked]="device.isSelected"
						(toggle)='onSelectDevice(device, $event)'
						[hasChild]="true">
						<p id="{{ componentId }}-list-item-{{ id }}-title" role="text" class="custom-control-label-text title">
							{{ 'hardwareScan.pluginTokens.' + device.title | translateDefault:device.title }}
							<span id="{{ componentId }}-list-item-{{ id }}-subname" role="text"
								class="subname">{{ 'hardwareScan.pluginTokens.' + device.name | translateDefault:device.name }}</span>
						</p>
					</vtr-material-checkbox>
				</div>
			</li>
		</div>
		<div class="col-12 px-0">
			<div class="options">
				<vtr-ui-hyperlink-button
					linkId="{{ componentId }}-select-all-link"
					hyperlinkStyle="xs-300-lightGray1"
					class="hyperlink-container"
					(hyperlinkClick)="onSelectAllDevices()"
					[label]=" 'hardwareScan.select' | translate "
					[disableTooltip]="true"
				></vtr-ui-hyperlink-button>
				<span class="select-item-subtitle">/</span>
				<vtr-ui-hyperlink-button
					linkId="{{ componentId }}-deselect-all-link"
					hyperlinkStyle="xs-300-lightGray1"
					(hyperlinkClick)="onDeselectAllDevices()"
					[label]=" 'hardwareScan.deselect' | translate "
					[disableTooltip]="true">
				</vtr-ui-hyperlink-button>
			</div>
		</div>
	</ul>
</div>
